module.exports = __webpack_public_path__ + "img/shopping-cart.b252a411.svg";